import { VIDEO, AUDIO } from 'Constants/General';
import { ModuleList, LessonList, UserListPrivateLessons } from './Request';

export const lessonList = async ({ moduleId }) => LessonList({ moduleId });

export const moduleList = async ({ courseId, userId }) => {
  const enrolledPrivateLessons = await UserListPrivateLessons({ userId });
  const mappedPrivateLessons = enrolledPrivateLessons.map(lesson => lesson.lessonId);
  const modulesFetch = await ModuleList({ courseId });
  const modules = modulesFetch?.filter(module => !module.isDraft);
  const promises = [];

  modules.forEach((module, index) => {
    promises.push(
      lessonList({ moduleId: module.id }).then(lessons => {
        const filteredLessons = lessons?.filter(
          lesson => lesson.isDraft !== true && (lesson.LessonType.name === VIDEO || lesson.LessonType.name === AUDIO)
        );
        modules[index].lessons = filteredLessons.filter(
          lesson => lesson.isPrivate !== true || mappedPrivateLessons.includes(lesson.id)
        );
        return null;
      })
    );
  });

  await Promise.allSettled(promises);

  return modules;
};

export default {
  moduleList,
};
